import _ from 'lodash'
import setCookie from '../session/setCookie'

export default function accorSecurePaymentForm(reservationForm, reservationData, urlData, sessionId) {
	const appContainer = document.getElementById('bk-flow')
	appContainer.insertAdjacentHTML('beforeend', reservationForm)

	let secureCookiePayload = constructRedirectCookiePayload(reservationData, urlData, sessionId)

	if (
		document.forms['downloadform3D'] &&
		!_.isEmpty(secureCookiePayload)
	) {
		setCookie('flowSecureReservationData', JSON.stringify(secureCookiePayload), 1)
		document.forms['downloadform3D'].submit()
	} else if (
		document.forms['PAEnrollForm'] &&
		!_.isEmpty(secureCookiePayload)
	) {
		setCookie('flowSecureReservationData', JSON.stringify(secureCookiePayload), 1)
		document.forms['PAEnrollForm'].submit()
	} else if (
		document.forms['threedform'] &&
		!_.isEmpty(secureCookiePayload)
	) {
		setCookie('flowSecureReservationData', JSON.stringify(secureCookiePayload), 1)
		document.forms['threedform'].submit()
	}
}

export function accorSecurePaymentRedirect(redirectUrl, reservationData, urlData, sessionId) {
	let secureCookiePayload = constructRedirectCookiePayload(reservationData, urlData, sessionId)

	if (
		redirectUrl &&
		!_.isEmpty(secureCookiePayload)
	) {
		setCookie('flowSecureReservationData', JSON.stringify(secureCookiePayload), 1)
		window.location.replace(redirectUrl)
	}
}

function constructRedirectCookiePayload(reservationData, urlData, sessionId) {
	const confirmationNumber = _.get(reservationData, '[0].id', '')
	const lastName = _.get(reservationData, '[0].resGuests.profiles[0].profile.customer.personName.surName', '')
	const arrivalDate = _.get(reservationData, '[0].roomStays[0].timeSpan.start', '')
	const primaryLangId = _.get(urlData, 'primaryLangId', 'en')
	const reservationIds = _.get(reservationData, '[0].resGlobalInfo.hotelReservationIds', [])

	let bookingId = null

	for (const resKey in reservationIds) {
		const currentId = reservationIds[resKey]
		const resIdType = _.get(currentId, 'resIdType', null)
		const resIdValue = _.get(currentId, 'resIdValue', null)

		if (
			resIdType === '34' &&
			resIdValue
		) {
			bookingId = resIdValue
		}
	}

	let redirectCookiePayload = {
		confirmationNumber: confirmationNumber,
		bookingId: bookingId,
		lastName: lastName,
		arrivalDate: arrivalDate,
		primaryLangId: primaryLangId,
		sessionId: sessionId,
	}

	return redirectCookiePayload
}


// WEBPACK FOOTER //
// ./src/utilities/payment/accorSecurePayment.js